import { Injectable } from "@angular/core";
import { APP_SETTINGS } from "../../shared/models/backofficeConfiguration";
import { ExecuteService } from "../../shared/services/executeService.service";
import { ErrorHandlerService } from "../../shared/services/errorHandler.service";
import { map, catchError } from "rxjs/operators";
import { Observable } from "rxjs/Observable";
import { CacheService } from "../../shared/services/cache.service";
import { Feed } from "../model/Feed";

@Injectable()
export class FeedsService {
    private postApiURL = APP_SETTINGS.PostApiUrl;

    constructor(private cacheService: CacheService,
        private executeService: ExecuteService,
        private errorHandler: ErrorHandlerService) { }

    public GetFeeds(): Observable<Feed[]> {
        const url = `${this.postApiURL}/api/feedManager/get`;
        return this.cacheService.get('getFeeds', this.executeService.ExecuteWithToken('get', url)
            .pipe(
                map(response => this.mapFeedModels(response.Values)),
                catchError(this.errorHandler.handleError<object[]>('FeedsService_GetFeeds', []))
        ));
    }

    private mapFeedModels(feeds: any[]): Feed[] {
        let response: Feed[] = [];
        if (response != null) {
            response = feeds.map(c => ({
                id: c.Id,
                name: c.Name,
                contentTypeId: c.ContentTypeId
            }));
        }
        return response;
    }
}


// WEBPACK FOOTER //
// ./src/app/postTranslations/services/feeds.service.ts